const info = require('./info')
const rates = require('./rates')
const numberUtils = require('../utils/number')

const {
  hoursInDay,
} = require('../settings')

const linkBasedPrice = ({
  resource,
  amount,
  unit = 'day',
  overrides = {},
  markups,
  preRounding,
  ignoreRates,
  mergeAdjustments,
}) => {

  let useAmount = amount
  const baseline = info.baseLine(resource)

  if(overrides.adjustment) {
    useAmount += overrides.adjustment
  }

  if(info.isBaselineBased(resource) && info.baseLine(resource) > 0) {
    useAmount /= baseline
  }

  const rawUseAmount = useAmount

  if(preRounding) {
    useAmount = numberUtils.twoDpRaw(useAmount)
  }

  const links = resource.links || []
  const linkOverrides = overrides && overrides.links ? overrides.links : []

  const linkPrices = links
    .map((link, i) => {

      const baseLinkPrice = info.linkPrice(link)
      const baseLinkAmount = info.linkAmount(link)

      const linkOverride = linkOverrides[i]

      const amountOverriden = linkOverride && linkOverride.amount
      const priceOverriden = linkOverride && linkOverride.price

      let linkAmount = amountOverriden ? linkOverride.amount : baseLinkAmount
      const linkPrice = priceOverriden ? linkOverride.price : baseLinkPrice

      if(baseLinkPrice) {
        let unit = null
        let baseUnit = null

        if(info.isTimeBased(resource)) {
          unit = unit
          baseUnit = unit
        }
        else if(info.isBaselineBased(resource)) {
          unit = info.baseUnit(resource) //`${numberUtils.twoDp(useAmount * info.baseLine(resource))} ${info.baseUnit(resource)}`
          baseUnit = info.baseUnit(resource) //`${info.baseLine(resource)} ${info.baseUnit(resource)}`
        }

        let useLinkAmount = amount
        let linkUnitPrice = priceOverriden ? linkPrice : linkPrice / baseline

        if(overrides.adjustment) {
          useLinkAmount += overrides.adjustment
        }

        if(linkOverride && linkOverride.amount) {
          useLinkAmount = linkOverride.amount
        }

        const reportLinkAmount = useLinkAmount

        if(linkOverride && linkOverride.adjustment) {
          useLinkAmount += linkOverride.adjustment
        }

        const calculatedPrice = info.markupApply({
          resourceType: link.resource.type,
          markups,
          price: {
            price: useLinkAmount * linkUnitPrice,
            amount: reportLinkAmount,
            unit,
            base: {
              price: linkUnitPrice,
              amount: 1,
              unit: baseUnit,
            },
            overrides: linkOverride,
          }
        })
        
        calculatedPrice.link = link
        return calculatedPrice
      }
      else {
        let passAmount = amountOverriden ? linkAmount : rawUseAmount * linkAmount

        if(preRounding) {
          passAmount = numberUtils.twoDpRaw(passAmount)
        }

        const linkArgs = {
          resource: link.resource,
          amount: passAmount,
          // inject the resource overrides
          overrides: linkOverride,
          markups,
          preRounding,
          ignoreRates,
          mergeAdjustments,
        }
        if(info.isTimeBased(resource)) {
          linkArgs.unit = unit
        }
        const calculatedPrice = price(linkArgs)
        calculatedPrice.link = link
        calculatedPrice.overrides = linkOverride
        return calculatedPrice
      }      
    })

  const totalPrice = linkPrices
    .reduce((all, linkPrice) => {
      all.price += linkPrice.price
      return all
    }, {
      price: 0,
      amount,
      unit: info.isTimeBased(resource) ? unit : info.baseUnit(resource),
      base: {
        price: 0,
        amount: info.isBaselineBased(resource) ? info.baseLine(resource) : 1,
        unit: info.isTimeBased(resource) ? unit : info.baseUnit(resource),
      }
    })


  const baseRatio = totalPrice.amount > 0 ?
    totalPrice.base.amount / totalPrice.amount :
    0

  totalPrice.base.price = totalPrice.price * baseRatio
  totalPrice.links = linkPrices

  return totalPrice
}

const rateBasedPrice = ({
  resource,
  amount = 1,
  unit,
  overrides,
  markups,
  ignoreRates,
  mergeAdjustments,
}) => {

  overrides = overrides || {}

  let useAmount = displayAmount = amount
  if(overrides.adjustment) {
    useAmount += overrides.adjustment
    if(mergeAdjustments) {
      displayAmount += overrides.adjustment
    }
  }
  
  const cheapestRate = rates.getCheapestRate({
    resource,
    amount: useAmount,
    unit,
    overrides,
    ignoreRates,
  })

  if(!cheapestRate) {
    return {
      price: 0,
      amount: displayAmount,
      unit,
      unknown: true,
      base: {
        price: 0,
        amount: 1,
        unit,
      }
    }
  }

  const isTimeBased = info.isTimeBased(resource)
  
  return info.markupApply({
    resourceType: resource.type,
    markups,
    price: {
      price: cheapestRate.price,
      amount: displayAmount,
      unit: isTimeBased ? unit : info.baseUnit(resource),
      base: {
        price: cheapestRate.rateTotalPrice,
        unitPrice: cheapestRate.rateUnitPrice,
        amount: cheapestRate.rate.amount || 1,
        unit: isTimeBased ? cheapestRate.rate.unit : info.baseUnit(resource),
      }
    }
  })
}

const timeBasedPrice = ({
  resource,
  amount = 1,
  unit = 'day',
  overrides = {},
  markups,
  preRounding,
  ignoreRates,
  mergeAdjustments,
}) => {

  // if it's rate based - work out what the base unit
  // is based on the rate we pick
  if(info.isRateBased(resource)) {
    return rateBasedPrice({
      resource,
      amount,
      unit,
      overrides,
      markups,
      ignoreRates,
      mergeAdjustments,
    })
  }
  else if(info.isLinkBased(resource)) {
    return linkBasedPrice({
      resource,
      amount,
      unit,
      overrides,
      markups,
      preRounding,
      ignoreRates,
      mergeAdjustments,
    })
  }

  let useAmount = displayAmount = amount
  if(overrides && overrides.adjustment) {
    useAmount += overrides.adjustment
    if(mergeAdjustments) {
      displayAmount += overrides.adjustment
    }
  }

  // otherwise we assume the resource is day based
  const dayRate = info.basePrice(resource, overrides)
  const unitDesc = info.getUnitDescriptor(unit)

  if(unitDesc.hours) {
    const hourRate = dayRate / hoursInDay
    return info.markupApply({
      resourceType: resource.type,
      markups,
      price: {
        price: hourRate * unitDesc.hours * useAmount,
        amount: displayAmount,
        unit,
        base: {
          price: dayRate,
          amount: 1,
          unit: 'day',
        },
      }
    })
  }
  else {
    return info.markupApply({
      resourceType: resource.type,
      markups,
      price: {
        price: dayRate * unitDesc.days * useAmount,
        amount: displayAmount,
        unit,
        base: {
          price: dayRate,
          amount: 1,
          unit: 'day',
        }
      }
    })
  }
}

const defaultPrice = ({
  resource,
  amount = 1,
  overrides = {},
  markups,
  mergeAdjustments,
}) => {

  let useAmount = displayAmount = amount
  if(overrides.adjustment) {
    useAmount += overrides.adjustment
    if(mergeAdjustments) {
      displayAmount += overrides.adjustment
    }
  }

  return info.markupApply({
    resourceType: resource.type,
    markups,
    price: {
      price: info.basePrice(resource, overrides) * useAmount,
      amount: displayAmount,
      unit: info.baseUnit(resource),
      base: {
        price: info.basePrice(resource, overrides),
        amount: 1,
        unit: info.baseUnit(resource),
      },
    }
  })
}

const price = ({
  resource,
  amount = 1,
  unit = 'day',
  overrides = {},
  markups,
  preRounding,
  ignoreRates,
  mergeAdjustments,
}) => {
  
  // labour, team, hire, waste
  if(info.isTimeBased(resource)) {
    return timeBasedPrice({
      resource,
      amount,
      unit,
      overrides,
      markups,
      preRounding,
      ignoreRates,
      mergeAdjustments,
    })
  }
  // template
  else if(info.isLinkBased(resource)) {
    return linkBasedPrice({
      resource,
      amount,
      unit,
      overrides,
      markups,
      preRounding,
      ignoreRates,
      mergeAdjustments,
    })
  }
  else if(info.isRateBased(resource)) {
    return rateBasedPrice({
      resource,
      amount,
      unit,
      overrides,
      markups,
      preRounding,
      ignoreRates,
      mergeAdjustments,
    })
  }
  // materials
  else {
    return defaultPrice({
      resource,
      amount,
      overrides,
      markups,
      preRounding,
      ignoreRates,
      mergeAdjustments,
    })
  }
}

module.exports = price